import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { ApplicationRestrictionRow } from './ApplicationRestrictionRow';
import { getApplicationRestrictions } from './redux/settingsSlices';

const mapStateToProps = (state: RootState) => ({
    appRestrictions: state.settings.applicationRestrictions
});

type Props = ReturnType<typeof mapStateToProps>;

const ApplicationRestrictions = ({ appRestrictions }: Props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getApplicationRestrictions.request());
    }, [dispatch]);

    return (
        <>
            {Object.values(appRestrictions).map(a => (
                <ApplicationRestrictionRow key={a.entityType} applicationRestriction={a} />
            ))}
        </>
    );
};

export default connect(mapStateToProps)(ApplicationRestrictions);
